<template>
  <div class="start-trial-button-with-pricing">
    <div class="start-trial-button-with-pricing__cta">
      <start-trial-button
        :cta-class="ctaClass"
        :cta-copy="ctaCopy"
        :signup-route="signupRoute"
        :event-category="eventCategory"
        :modifiers="['x-wide']" />
    </div>

    <div
      v-if="plans && trialDays && trialDays > 0 && showTrialEndDate"
      class="start-trial-button-with-pricing__trial-info">
      {{ trialInfo }}
    </div>
  </div>
</template>

<script>
import StartTrialButton from "@/shared/start-trial-button";
import { mapGetters } from "vuex";
export default {  name: "StartTrialButtonWithPricing",
  components: {
    StartTrialButton
  },
  props: {
    showTrialEndDate: {
      type: Boolean,
      default: false
    },
    signupRoute: {
      type: String,
      default: "",
      required: false
    },
    eventCategory: {
      type: String,
      default: "body-20210521-start_free_trial_cta"
    },
    ctaClass: {
      type: String,
      required: false,
      default: null
    },
    ctaCopy: {
      type: String,
      required: false,
      default: null
    }
  },
  computed: {
    ...mapGetters("plans", ["plans", "trialDays"]),
    trialInfo() {
      const now = new Date();
      now.setDate(now.getDate() + this.trialDays);

      const trialEndDate = this.$d(now, "dayOfMonth");

      return this.$t("trialInfo", { trialEndDate: trialEndDate });
    }
  },
  i18n: {
    dateTimeFormats: {
      en: {
        dayOfMonth: {
          month: "long",
          day: "numeric"
        }
      },
      de: {
        dayOfMonth: {
          month: "long",
          day: "numeric"
        }
      }
    },
    messages: {
      en: {
        trialInfo: "Cancel anytime before {trialEndDate} and you won’t ever be charged."
      },
      de: {
        trialInfo: "Testen kostet nichts: Kündige einfach vor dem {trialEndDate} und dir entstehen keine Kosten."
      }
    }
  } };
</script>

<style lang="scss" scoped>
.start-trial-button-with-pricing {

  &__cta {
    margin-bottom: $spacing-16;

    text-align: center;
  }

  &__trial-info {
    @include font-style(caption);

    text-align: center;
  }
}
</style>
